/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const VideoRegularV6 = (props) => (
  <Icon {...props} name="Video Regular V6">
    <path d="M15.489 3.731a1.106 1.106 0 0 0-1.063-.075l-2.87 1.316v-.528c0-.982-.796-1.778-1.778-1.778h-8C.796 2.666 0 3.462 0 4.444v7.111c0 .982.796 1.778 1.778 1.778h8c.982 0 1.778-.796 1.778-1.778v-.528l2.869 1.316a1.11 1.11 0 0 0 1.576-1.035V4.666c0-.381-.192-.728-.511-.936zm-5.267 7.825a.444.444 0 0 1-.444.444h-8a.444.444 0 0 1-.444-.444V4.445c0-.245.199-.444.444-.444h8c.245 0 .444.199.444.444v7.111zm4.445-.57-3.111-1.425V6.439l3.111-1.426v5.973z" />
  </Icon>
);

export default VideoRegularV6;
